import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDebounce } from '../../hooks/useDebounce';

const SearchForm = React.forwardRef(
  (
    { defaultQuery = '', performSearch, placeholder = '', children, onSubmit },
    ref
  ) => {
    const [query, setQuery] = useState(
      defaultQuery || new URLSearchParams(window.location.search).get('q') || ''
    );

    const debouncedSearch = useDebounce(
      (value) => performSearch(value.length > 1 ? value : ''),
      500
    );

    const handleChange = ({ target: { value } }) => {
      setQuery(value);
      debouncedSearch(value);
    };

    const handleSubmit = (e) => {
      if (onSubmit) return onSubmit(e);
      e.preventDefault();
      performSearch(query);
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="has-feedback">
          <input
            ref={ref}
            type="text"
            name="q"
            value={query}
            placeholder={placeholder}
            className="form-control"
            onChange={handleChange}
            autoComplete="off"
            aria-label="Search"
          />
          {children || (
            <span className="glyphicon glyphicon-search form-control-feedback" />
          )}
        </div>
      </form>
    );
  }
);

SearchForm.propTypes = {
  defaultQuery: PropTypes.string,
  performSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
};

export default SearchForm;
